'use client';

import { Toaster } from "@/components/ui/toaster";
import { Toaster as SonnerToaster } from "sonner";
import Header from '@/components/layout/header';
import Footer from '@/components/layout/footer';
import { AppContent } from '@/components/layout/app-content';
import { SupabaseAuthProvider } from '@/contexts/SupabaseAuthContext';
import { usePathname } from 'next/navigation';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import AiReferralTracker from '@/components/AiReferralTracker';

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  // Hide header/footer for admin pages (they have their own layout).
  // Profile pages render their own slim portal bar instead of the marketing nav.
  // Funnel pages (/go/*) render a distraction-free shell in go/layout.tsx.
  const isAdminPage = pathname?.startsWith('/admin');
  const isProfilePage = pathname?.startsWith('/profile');
  const isFunnelPage = pathname?.startsWith('/go');
  const hasOwnShell = isAdminPage || isProfilePage || isFunnelPage;
  const hideFooter = pathname === '/aubree-ai' || hasOwnShell;

  return (
    <SupabaseAuthProvider>
      <AppContent>
        {!hasOwnShell && <Header />}
        <main className={`flex-grow ${!hasOwnShell ? 'pt-20 lg:pt-[115px]' : ''}`}>
          {children}
        </main>
        {!hideFooter && <Footer />}
        <Toaster />
        {/* Admin surfaces (Content Factory etc.) toast via sonner; without this
            mount every sonner toast (including error messages) is silently lost. */}
        <SonnerToaster richColors closeButton position="bottom-right" />
        <GoogleAnalytics />
        <AiReferralTracker />
      </AppContent>
    </SupabaseAuthProvider>
  );
}
